"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var SimpleExampleFAB_1 = require("./SimpleExampleFAB");
var StylingExampleFAB_1 = require("./StylingExampleFAB");
var PropertiesFAB_1 = require("./PropertiesFAB");
exports.ComponentFABPage = function () { return (React.createElement(common_1.Page, { headerText: "Floating Action Button" },
    React.createElement(common_1.Paragraph, null, "Floating Action Button, or simply FAB, is used as a main action in a view."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(SimpleExampleFAB_1.SimpleExampleFAB, null),
    React.createElement(StylingExampleFAB_1.StylingExampleFAB, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesFAB_1.PropertiesFAB, null))); };
exports.ComponentFABPage.displayName = 'ComponentFABPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFABPage/ComponentFABPage.tsx
// module id = 668
// module chunks = 0